import RdfResourceImpl from "./RdfResource.mjs";
export { crossBoundaries } from "./lib/path.mjs";
export { default as ResourceFactory } from "./lib/ResourceFactory.mjs";
export * from "./lib/decorators/index.mjs";
export default RdfResourceImpl;